export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aesthetic%20minimal%20desk%20setup%20with%20modern%20laptop%20showing%20colorful%20data%20charts%20and%20spreadsheet%20grid%20surrounded%20by%20folded%20cream%20and%20beige%20fashion%20items%20a%20small%20ceramic%20vase%20with%20dried%20flowers%20leather%20notebook%20and%20gold%20pen%20on%20light%20oak%20wood%20surface%20warm%20gentle%20sunlight%20from%20left%20window%20casting%20soft%20shadows%20cozy%20sophisticated%20atmosphere%20editorial%20photography%20high%20detail%20harmonious%20composition&width=1600&height=800&seq=hero-main-v2-2026&orientation=landscape"
          alt="Itaobuy spreadsheet hub workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4">
            Best Itaobuy Sheet Platform
            <br />
            <span className="text-accent-300">& Comparison Hub 2026</span>
          </h1>
          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover the most trusted itaobuy sheet systems, compare features, and find the best
            itaobuy spreadsheet solution for your needs — all in one place. Updated daily with
            independent analysis.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-accent-500 text-background-50 font-semibold text-base rounded-full hover:bg-accent-600 transition-all duration-200 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Itaobuy Sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold text-base rounded-full hover:bg-primary-600 transition-all duration-200 transform hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
            <a
              href="#categories"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/20 backdrop-blur-sm text-white font-semibold text-base rounded-full border border-white/30 hover:bg-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Explore Categories
            </a>
          </div>

          <p className="mt-6 text-xs md:text-sm text-white/60">
            Updated daily &bull; Independent analysis &bull; No hidden promotions
          </p>
        </div>
      </div>
    </section>
  );
}